import { render } from "./course_list.vue?vue&type=template&id=4d80a940&scoped=true&ts=true"
import script from "./course_list.vue?vue&type=script&lang=ts"
export * from "./course_list.vue?vue&type=script&lang=ts"

import "./course_list.vue?vue&type=style&index=0&id=4d80a940&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d80a940"]])

export default __exports__